//opening times for room reservation
const BSZ_TIMESLOTS = [
  { id: 1, hour: 7, minute: 20 },
  { id: 2, hour: 8, minute: 25 },
  { id: 3, hour: 10, minute: 50 },
  { id: 4, hour: 11, minute: 35 },
  { id: 5, hour: 12, minute: 20 },
  { id: 6, hour: 13, minute: 5 },
  { id: 7, hour: 13, minute: 55 },
  { id: 8, hour: 14, minute: 40 },
  { id: 9, hour: 15, minute: 25 },
  //{ id: 2, hour: 7, minute: 0 }, only for development, change back to id: 5. Comment out at DEPLOYMENT!
];

function getWeekday(isDeveloperMode, now = new Date()) {
  const day = now.getDay();

  if (isDeveloperMode && (day === 0 || day === 6)) {
    return 5; // Friday
  }

  if (day === 0 || day === 6) {
    return null;
  }

  return day;
}

function getCurrentTimeslot(now = new Date()) {
  const minutes = now.getHours() * 60 + now.getMinutes();
  // console.log("NOW:", now);

  for (let i = BSZ_TIMESLOTS.length - 1; i >= 0; i--) {
    const slot = BSZ_TIMESLOTS[i];
    const slotMinutes = slot.hour * 60 + slot.minute;

    if (minutes >= slotMinutes) {
      return slot.id;
    }
  }

  return null;
}

export function isRoomAvailableNow(
  room,
  now = new Date(),
  isBszAdmin = false,
  isTeacherView = false,
  isStudentView = false,
) {
  const isDeveloperMode = isBszAdmin;
  // return true;
  if (isBszAdmin && !isTeacherView && !isStudentView) {
    return true;
  }
  if (!room.availability?.length) {
    return false;
  }

  const weekday = getWeekday(isDeveloperMode, now);
  const timeslotId = getCurrentTimeslot(now);

  if (!weekday || !timeslotId) {
    return false;
  }

  return room.availability.some(
    (a) => a.weekday === weekday && a.timeslotId === timeslotId,
  );
}
